<template>
  <div class="row text-center mt-0 mb-0">
    <div class="col-md-12">
      <small class="text-muted d-block text-uppercase font-weight-bold mb-2"
             style="font-size: 11px; letter-spacing: 0.8px;">
        <i class="fa-solid fa-pen-nib mr-1 text-primary"></i> Neue Signatur zeichnen
      </small>
      <canvas
          id="signature-canvas"
          width="350"
          height="200"
          style="border: 1px solid rgb(208, 208, 208);"
          ref="canvasRef"></canvas>
      <input v-model="formData.digitalSignature" type="hidden"/>
    </div>

    <div class="col-md-12">
      <div class="d-flex flex-row justify-content-center align-items-center">
        <div style="width: 350px; margin: 0 auto">
          <SelectVue
              v-model="formData.note"
              disabled="disabled"
              :options="noteDropdown"
              :is-clear="true"
              placeholder="Bemerkung"/>
        </div>
      </div>
    </div>
  </div>

  <div
      class="d-flex flex-column flex-sm-row justify-content-center align-items-center modal-buttons mt-3 pt-3 border-top w-100 gap-2"
      style="border-top-color: #eef1f5 !important;">
    <button
        class="btn text-danger border border-danger font-weight-bold px-4 w-100 w-sm-auto d-inline-flex align-items-center justify-content-center"
        style="min-height: 38px;"
        @click="clearSignature">
      <i class="fa-solid fa-eraser mr-2"></i>
      {{ $t('general.button.delete') }}
    </button>

    <button
        class="btn btn-primary font-weight-bold ml-0 ml-md-3 mt-3 mt-md-0 px-4 w-100 w-sm-auto d-inline-flex align-items-center justify-content-center"
        style="min-height: 38px;" @click="saveSignature">
      <i class="fa-solid fa-floppy-disk mr-2"></i> {{ $t('general.button.save') }}
    </button>
  </div>
</template>

<script setup>
import SignaturePad from 'signature_pad';
import {defineEmits, defineProps, onMounted, ref, toRefs} from 'vue';
import portalCMCService from "@/api/Portal/CaseManagementCoaching";
import {ErrorToast, SuccessToast} from "@/components/VueToast";
import {useI18n} from "vue-i18n";
import SelectVue from "@/components/SelectVue.vue";

const emit = defineEmits([
  'update:modelValue',
  'update:missingDigitalSignature',
  'update:submitForm'
]);
const canvasRef = ref(null);
const isLoaded = ref(false);
const {t} = useI18n();
let signaturePad = null;

const props = defineProps({
  token: {
    type: String,
    required: true,
  },
  meetingId: {
    type: [Number, String],
    required: true,
  },
  meetingType: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const token = toRefs(props)['token'];
const meetingId = toRefs(props)['meetingId'];
const meetingType = toRefs(props)['meetingType'];
const noteDropdown = ref([
  {
    value: 'Online',
    label: 'Online'
  }
]);

const formData = ref({
  digitalSignature: '',
  token: token.value,
  meetingId: +meetingId.value,
  meetingType: meetingType.value,
  note: 'Online',
});

async function saveSignature() {

  console.log(formData.value)
  if (signaturePad && !signaturePad.isEmpty()) {
    formData.value.digitalSignature = signaturePad.toDataURL('image/png');
  } else {
    formData.value.digitalSignature = ''; // Clear if empty
  }

  try {
    await portalCMCService.saveCmcRemoteDigitalSignature(formData.value);

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    if (signaturePad && !signaturePad.isEmpty()) {
      emit('update:missingDigitalSignature', false);
    }

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

const clearSignature = () => {
  if (signaturePad) {
    signaturePad.clear();
    formData.value.digitalSignature = '';
  }
};

onMounted(async () => {
  if (canvasRef.value) {
    signaturePad = new SignaturePad(canvasRef.value, {
      backgroundColor: '#fff',
      penColor: 'rgb(0, 0, 0)',
    });
  }

  isLoaded.value = true;
});
</script>

<style scoped>
canvas {
  cursor: crosshair;
}

.modal_buttons_container {
  display: flex;
  gap: 165px; /* Adjust the gap as needed */
}
</style>